import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { selectDealerSelected } from 'app/pages/Header/selectors';
import { hasDealerContext } from 'utils/hasDealerContext';

export type NurturingJourneySettingsBreadcrumb = {
  label: string;
  link?: string;
  isActive?: boolean;
};

export const useNurturingJourneySettingsPage = () => {
  const location = useLocation();
  const selectedDealer = useSelector(selectDealerSelected);

  const breadcrumbsList = useMemo((): NurturingJourneySettingsBreadcrumb[] => {
    const fromState = (
      location.state as {
        breadcrumbsList?: NurturingJourneySettingsBreadcrumb[];
      } | null
    )?.breadcrumbsList;
    if (fromState?.length) {
      return fromState;
    }
    return [{ label: 'Nurturing Journey Settings', isActive: true }];
  }, [location.state]);

  const hasDealer = hasDealerContext(selectedDealer);
  const dealerObj =
    typeof selectedDealer === 'object' && selectedDealer !== null
      ? (selectedDealer as { site_title?: string; dealer?: string; _id?: string })
      : null;
  const dealerTitle = dealerObj?.site_title;
  const dealerId = dealerObj?.dealer || dealerObj?._id;

  return {
    breadcrumbsList,
    hasDealer,
    dealerTitle,
    dealerId,
  };
};
